import { createSlice } from "@reduxjs/toolkit";

const authenSlice = createSlice({
    name: 'authen',
    initialState: [],
    reducers: {
        login: (
            // state, action: PayloadAction<any>
        ) => {
        },
        logout: (
            // state, action: PayloadAction<any>
        ) => {
        }
    }
})

const { reducer, actions } = authenSlice;
export const { login, logout } = actions;
export default reducer;